import React, { useState, useCallback, useEffect } from 'react'
import Hamburger from './Hamburger'
import * as styles from './styles.module.scss'
import smiley from './account-smile.svg'

import { CONFIG } from '../../config'

const Links = () => (
  <nav className={styles.Links}>
    <a className={styles.Homelink} href={`${CONFIG.MARKETING_URL}`}>
      Home
    </a>
    <a
      className={styles.LinkMobileOnly}
      href={`${CONFIG.MARKETING_URL}all-plans`}
    >
      SIM plans
    </a>
    <a
      className={styles.LinkMobileOnly}
      href="https://help.smarty.co.uk/en/"
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      Help &amp; support
    </a>
    <a className={styles.Link} href={`${CONFIG.MARKETING_URL}about-us`}>
      About
    </a>
    <a className={styles.Link} href={`${CONFIG.MARKETING_URL}refer-a-friend`}>
      Bag up to £20
    </a>
    <a className={styles.Link} href={`${CONFIG.MARKETING_URL}group-plans`}>
      Group plans
    </a>
    <a className={styles.LinkTagNew} href={`${CONFIG.MARKETING_URL}app`}>
      App
    </a>
  </nav>
)

const ActionLinks = () => (
  <nav className={styles.LinksRow}>
    <a className={styles.LoginLink} href={`${CONFIG.DASHBOARD_URL}`}>
      <img src={smiley} alt="" /> Log in
    </a>
    <a className={styles.ActivateLink} href={`${CONFIG.DASHBOARD_URL}activate`}>
      Activate SIM
    </a>
  </nav>
)

const Navbar = () => {
  const [navbarOpen, setNavbarOpen] = useState(false)

  const KEYCODE_TAB = 9

  const handleResize = useCallback(() => {
    if (window.innerWidth > 850) setNavbarOpen(false)
  }, [])

  const toggleNav = () => {
    setNavbarOpen((existing) => !existing)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [handleResize])

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown)

    return () => window.removeEventListener('keydown', handleKeydown)
  })

  const handleKeydown = useCallback(
    (e) => {
      const navEl = document.getElementById('nav')
      const focusable = navEl.querySelectorAll(
        'button, [href], input, select, textarea, li, a,[tabindex]:not([tabindex="-1"])'
      )
      const firstFocusable = focusable[0]
      const lastFocusable = focusable[focusable.length - 1]
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed || !navbarOpen) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusable) {
          lastFocusable.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        /* eslint-disable no-lonely-if */
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus()
          e.preventDefault()
        }
        /* eslint-enable no-lonely-if */
      }
    },
    [navbarOpen]
  )

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]
    if (navbarOpen) {
      body.style.overflow = 'hidden'
    } else {
      body.style.overflow = 'unset'
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [navbarOpen, handleKeydown])

  const navbarStyles = navbarOpen
    ? `${styles.Navbar} ${styles.NavbarOpen}`
    : styles.Navbar
  const subNavStyles = navbarOpen
    ? `${styles.subNav} ${styles.Open}`
    : styles.subNav

  return (
    <div id="nav" role="navigation" className={navbarStyles}>
      <div className={styles.Container}>
        <a className={styles.Logo} href={`${CONFIG.MARKETING_URL}`}>
          Home
        </a>
        <div className={subNavStyles}>
          <ActionLinks />
          <Links />
        </div>
        <Hamburger open={navbarOpen} onClick={toggleNav} />
      </div>
    </div>
  )
}

export default Navbar
